import { Checkbox } from '@shared/components/forms';
import { useCallback, useContext } from 'react';
import { ProductTableContext } from '../../../contexts/product-table-context';
import type { Filters } from '../../../hooks/products';
import { type FilterComponent, withFilterField } from './filter-component';
import { FilterWrapper } from './filter-wrapper';

/** The `Filters` fields that are plain on/off switches. */
type BooleanFilterField = {
  [K in keyof Filters]-?: NonNullable<Filters[K]> extends boolean ? K : never;
}[keyof Filters];

/** A labelled checkbox bound to one boolean `Filters` field. */
export function checkboxFilter(field: BooleanFilterField, label: string): FilterComponent {
  return withFilterField(field, function CheckboxFilter() {
    const { filters, setFilters } = useContext(ProductTableContext);

    const onChange = useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        setFilters((prev: Filters) => ({ ...prev, [field]: event.target.checked }));
      },
      [setFilters]
    );

    return (
      <FilterWrapper label={label}>
        <Checkbox invalid={false} checked={filters[field] === true} onChange={onChange} />
      </FilterWrapper>
    );
  });
}
